//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function(module) {

    //Use strict mode
    'use strict';

    /**
     * 
     */
    module.SolarInstallationModel = function() {
        this._roofModel = undefined;
        this._pvPanelModel = undefined;
        this._thermalPanelModel = undefined;
        this._thermalCombinedModel = undefined;// #2963
        this._buildingJsonFolder = undefined;
        this._bddBackendController = "/backend/getInfosBDD.php";
        this._differentiationByRoofSide = undefined;
        this._roofIds = [];
        this._roofInfos = undefined;
        this._userInfos = { // default values
            hasElectricalBoiler:  true,
            hasElectricalHeating: true,
            numberOfFloors:       1,
            numberOfAirConditioner: 1, // #4308
            numberOfInhabitants:  1,
            usedRoofArea:         50,
            userCategory:         "individual",
            classeDPE:"D",// #2963
            heatingSystemType:"Electrique"// #2963
        };
        this._waitForModelToBeSet = am.utils.controllablePromise(); // Promise which will resolve to true when the parameter file is loaded
        this._waitForComputationToComplete = am.utils.controllablePromise();  // Promise which will resolve to true when the results are ready to be querried
        this._areRoofInfosPending = false;
        this._areUserInfosPending = false;
    };

    /**
     * Class constructor
     * @constructor
     *
     * @param {Object} config - Object holding the model configuration. The following keys are accepted:
     *      - 
     */
    module.SolarInstallationModel.prototype.init = function(config) {
        // Get the model parameters
        var _this = this;
        $.ajax({
            dataType: "json",
            url: "/data/params.js",
            success: function(params) {
                console.log("Successfully loaded parameters of the solar installation model");
                if (config.differentiationByRoofSide == true) {
                    _this._roofModel = am.utils.roofSideCollection(params);
                } else {
                    _this._roofModel = am.utils.pixelizedRoof(config, params);
                }
                _this._pvPanelModel = am.utils.pvPanelInstallation(_this._roofModel, params);
                _this._thermalPanelModel = am.utils.thermalPanelInstallation(_this._roofModel, params);
                _this._thermalCombinedModel = am.utils.thermalCombinedInstallation(_this._roofModel, params);// #2963
                _this._waitForModelToBeSet.resolve();
            },
            error: function(jqXHR, textStatus) {
                console.error("Cannot load parameters of the solar installation model: " , textStatus, jqXHR);
            }
        });
        this._differentiationByRoofSide = config.differentiationByRoofSide;
        this._buildingJsonFolder = config.buildingJsonFolder;
    };

    module.SolarInstallationModel.prototype.destroy = function() {
        // nothing to do
    };

    module.SolarInstallationModel.prototype.setRoofId = function(roofId) {
        this._areRoofInfosPending = true;
        this._waitForComputationToComplete = am.utils.controllablePromise(); // reset promise to a waiting state

        var _this = this;
        this._waitForModelToBeSet.then(function() {
            _this._getRoofInfos(roofId, function(roofInfos) {
                _this._areRoofInfosPending = false;
                _this._roofIds = [roofId];
                _this._roofInfos = roofInfos;
                _this._roofModel.setRoofInfos(_this._roofInfos);
                if (_this.isSet()) {
                    _this._computeResults();
                }
            })
        });
    };

    module.SolarInstallationModel.prototype.addRoofId = function(roofId) {
        this._areRoofInfosPending = true;
        this._waitForComputationToComplete = am.utils.controllablePromise(); // reset promise to a waiting state

        var _this = this;
        this._waitForModelToBeSet.then(function() {
            _this._getRoofInfos(roofId, function(roofInfos) {
                _this._areRoofInfosPending = false;
                if (_this._differentiationByRoofSide) {
                    _this._roofIds.push(roofId);
                    _this._roofInfos.concat(roofInfos);
                } else {
                    _this._roofIds = [roofId];
                    _this._roofInfos = roofInfos;
                }
                _this._roofModel.setRoofInfos(_this._roofInfos);
                if (_this.isSet()) {
                    _this._computeResults();
                }
            });
        });
    };

    module.SolarInstallationModel.prototype.removeRoofId = function(roofId) {
        this._areRoofInfosPending = true;
        this._waitForComputationToComplete = am.utils.controllablePromise(); // reset promise to a waiting state

        var _this = this;
        this._waitForModelToBeSet.then(function() {
            _this._areRoofInfosPending = false;
            if (_this._differentiationByRoofSide) {
                var roofIndex = _this._roofIds.indexOf(roofId);
                if (roofIndex != -1) {
                    _this._roofIds.splice(roofIndex, 1);
                    _this._roofInfos.splice(roofIndex, 1);
                
                    if (_this._roofIds.length > 0) {
                        _this._roofModel.setRoofInfos(_this._roofInfos);
                        if (_this.isSet()) {
                            _this._computeResults();
                        }
                    }
                }
            } else {
                _this._roofIds = [];
                _this._roofInfos = undefined;
            }
        });
    };

    module.SolarInstallationModel.prototype.setUserInfos = function(userInfos) {
        this._areUserInfosPending = true;
        this._waitForComputationToComplete = am.utils.controllablePromise(); // reset promise to a waiting state

        var _this = this;
        return this._waitForModelToBeSet.then(function() {
            _this._userInfos = userInfos;
            _this._areUserInfosPending = false;
            if (_this.isSet()) {
                _this._computeResults();
            }
        });
    };

    module.SolarInstallationModel.prototype.getResults = function() {
        var _this = this;
        return this._waitForComputationToComplete.then(function() {
            var properties = {};
            [_this._roofModel, _this._pvPanelModel, _this._thermalPanelModel, _this._thermalCombinedModel].forEach(function(model) {
                properties = am.utils.mergeObjects(properties, model.getProperties());
            });
            return properties;
        });
    };

    module.SolarInstallationModel.prototype.getResult = function(property) {
        var _this = this;
        return this._waitForComputationToComplete.then(function() {
            var models = [_this._roofModel, _this._pvPanelModel, _this._thermalPanelModel, _this._thermalCombinedModel];
            for (var iModel = 0, nModels = models.length; iModel < nModels; ++iModel) {
                if(typeof models[iModel] != "undefined"){
                    var value = models[iModel].getProperty(property);
                    if (value != undefined) {
                        return value;
                    }
                }
            }
        });
    };

    module.SolarInstallationModel.prototype.isSet = function() {
        return !this._areUserInfosPending && this._userInfos && !this._areRoofInfosPending && this._roofIds.length > 0;
    };

    module.SolarInstallationModel.prototype._computeResults = function() {
        // Throw an event to inform listeners about the start of the computation
        am.eventManager.trigger('roof_irradiation_computation_started', this._roofModel.getProperty("maxAvailableRoof3DArea"));

        // Launch the computation
        var _this = this;
        setTimeout(function() { // delay the computation by 10ms to allow the waiting bar to appear on the screen for large roofs...
            //_this._roofModel.computeAnnualIrradiation(_this._userInfos);
            _this._pvPanelModel.computeProperties(_this._userInfos);
            _this._thermalPanelModel.computeProperties(_this._userInfos);
            _this._thermalCombinedModel.computeProperties(_this._userInfos);// #2963

            // Throw an event to inform the listeners that the computation has ended
            am.eventManager.trigger('roof_irradiation_computation_ended');

            // Resolve the promise linked to the computation
            _this._waitForComputationToComplete.resolve();
        }, 10);
    };

    module.SolarInstallationModel.prototype._getRoofInfos = function(roofId, callback) {        
        var url = this._differentiationByRoofSide ? 
            this._bddBackendController :
            this._buildingJsonFolder + "/" + roofId + ".json";

        var _this = this;
        $.ajax({
            dataType: 'json',
            data: 'getInfos=roof&IDroof=' + roofId,
            type: "POST",
            url: url,
            success: function(roofInfos) {
                roofInfos.id = roofId;
                callback(roofInfos);
            },
            error: function(msg,stat, settings) {
                console.log("Error getting infos from roof ", roofId, ": ", msg, settings);
            }
        });
    };

    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Returns a new instance of class am.SolarInstallationModel
     *
     * @param {Object} config - Configuration object to be passed to the constructor of class am.SolarInstallationModel
     * @return {am.SolarInstallationModel} - New instance of class am.SolarInstallationModel 
     */
    module.solarInstallationModel = function(config) {
        var model = new am.SolarInstallationModel();
        model.init(config);
        return model;
    };

    return module;

})(am.utils || {});